

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ColorPickerComponent extends Vue {
  @Prop() value?: string | null;
  @Prop() label?: string | null;
  color?: string | null;
  current?: string | null = null;
  isMenuOpen: boolean = false;

  @Watch("current")
  onChange() {
    this.color = this.current;
    this.$emit("input", this.current);
  }

  @Watch("color")
  onColorChange() {
    this.current = this.color;
  }

  created() {
    this.color = this.value;
  }

  selectedColor(ev: any): void {
    this.current = ev.hex;
  }
}
